import React from 'react'
import { GoMarkGithub } from 'react-icons/go'
import { FaDiscord, FaTwitter } from 'react-icons/fa'

import theme from '../utils/theme'
import { Box, Flex, Link, Text } from './system'
import { Container } from './containers'
import GatsbyMonogram from './logo/monogram'

const Social = ({ icon, href }) => (
  <Link href={href} color="grey.500" ml={3}>
    {icon}
  </Link>
)

const Footer = () => (
  <Container>
    <Flex as="footer" alignItems="center" color="grey.500" pt={7} pb={5}>
      <Box
        width="24px"
        height="24px"
        mr={3}
        css={{
          svg: {
            display: 'block',
            width: '100%',
          },
        }}
      >
        <GatsbyMonogram fill={theme.colors.grey['700']} />
      </Box>
      <Text as="p" fontSize={2} fontFamily="brand" m={0}>
        A{' '}
        <Link
          color="grey.900"
          css={{ textDecoration: 'none' }}
          href="https://www.gatsbyjs.org"
        >
          Gatsby
        </Link>{' '}
        thing.
      </Text>

      <Box ml="auto">
        <Social
          icon={<GoMarkGithub />}
          href="https://github.com/gatsbyjs/gatsby"
        />
        <Social icon={<FaTwitter />} href="https://twitter.com/gatsbyjs" />
        <Social icon={<FaDiscord />} href="https://gatsby.app/discord" />
      </Box>
    </Flex>
  </Container>
)

export default Footer
